import type { TableColumnDefinition, TableDefinitions } from '@gitbook/doc-core';
import { createPalette, PaletteCommandType, type PaletteDef } from '@gitbook/react-uikit';

import { definitionSpecs, getColumnTitle } from '../../ColumnDefinitions';

/**
 * Create a palette to prompt the selection of one or mutiple columns.
 */
export function pickColumnDefinitions(
    definition: TableDefinitions,
    onSelected: (selected: string[]) => void | PaletteDef,
    options: {
        /** Search placeholder */
        search?: string;
        /** Should it accept multiple selected values */
        multiple?: boolean;
        /** Current selection */
        selected?: string[];
        /** Filter the definition to display */
        filterDefinition?: (def: TableColumnDefinition) => boolean;
    } = {}
): PaletteDef {
    const {
        selected = [],
        search = 'Select columns…',
        multiple = false,
        filterDefinition = () => true,
    } = options;

    return createPalette({
        search: { placeholder: search },
        groups: [
            {
                key: 'columns',
                commands: Object.entries(definition)
                    .filter(([_columnId, colDef]) => filterDefinition(colDef))
                    .map(([columnId, colDef]) => {
                        const colDefSpec = definitionSpecs[colDef.type];

                        const isSelected = selected.includes(columnId);

                        return {
                            key: columnId,
                            title: getColumnTitle(colDef),
                            icon: colDefSpec.icon,
                            type: PaletteCommandType.CHECKBOX,
                            selected: isSelected,
                            trigger: () => {
                                if (multiple) {
                                    return onSelected(
                                        isSelected
                                            ? selected.filter((id) => id !== columnId)
                                            : [...selected, columnId]
                                    );
                                }
                                return onSelected(isSelected ? [] : [columnId]);
                            },
                        };
                    }),
            },
        ],
    });
}
